import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import SectionTitle from '../../../components/SectionTitle';
import SecondaryNav from '../../../components/SecondaryNav';
import { getWebNotificationsMeVboxNumber } from '../../../js/notifications/selectors';

const messages = defineMessages({
  title: {
    id: 'MeVbox.title',
    defaultMessage: 'Vocalbox',
  },
  list: {
    id: 'MeVbox.list.navLabel',
    defaultMessage: 'Received messages',
  },
  notifications: {
    id: 'MeVbox.notifications.navLabel',
    defaultMessage: 'Notifications',
  },
});

const MeVbox = ({
  intl: { formatMessage },
  children,
  notificationsQuantity,
}) => {
  const nav = [
    {
      id: 'MeVbox.list.linkLabel',
      href: '/phone/vbox/list',
      label: messages.list,
    },
    {
      id: 'MeVbox.notifications.linkLabel',
      href: '/phone/vbox/notifications',
      label: messages.notifications,
      notifications: notificationsQuantity,
    },
  ];
  return (
    <div className="border rounded h-100 bg-white">
      <SectionTitle>{formatMessage(messages.title)}</SectionTitle>
      <SecondaryNav tabs={nav} />
      <div className="yn-section-with-nav-scrolling">{children}</div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    notificationsQuantity: getWebNotificationsMeVboxNumber(state),
  };
}
export default injectIntl(connect(mapStateToProps)(MeVbox));
